export enum ComplianceTabType {
  ALL_DOCUMENTS = 'all_documents',
  FOLDERS = 'folders',
  AWAITING_APPROVAL = 'awaiting_approval',
  DELAYED = 'delayed',
  REJECTED = 'rejected',
}
